import React from "react";
import { Typography, Paper, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import FormTextField from "./FormTextField";
import { ExpertFormState } from "../../Models/expert";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

interface ValidationErrors {
  primaryResponsibilities?: string;
  problemSolvingAbilities?: string;
  knowledgeDepth?: string;
}

interface RolesAndResponsibilitiesProps {
  formState: ExpertFormState;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  validationErrors: ValidationErrors;
}

const RolesAndResponsibilities: React.FC<RolesAndResponsibilitiesProps> = ({
  formState,
  handleChange,
  validationErrors,
}) => {
  const { t } = useTranslation("expertForm");
  const { colors: workspace } = useWorkspaceColors();
  return (
    <Grid item xs={12}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          borderRadius: 2,
          border: `1px solid ${colors.gray200}`,
          borderLeft: `4px solid ${workspace.primary_dark}`,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: workspace.primary_dark,
            fontWeight: 600,
          }}
        >
          {t("expertForm.rolesAndResponsibilities")}
        </Typography>
        <FormTextField
          label={t("expertForm.primaryResponsibilities")}
          name="primaryResponsibilities"
          value={formState.primaryResponsibilities}
          onChange={handleChange}
          info={t("expertForm.primaryResponsibilitiesInfo")}
          minRows={1}
          error={!!validationErrors.primaryResponsibilities}
          helperText={validationErrors.primaryResponsibilities}
        />
        <FormTextField
          label={t("expertForm.problemSolvingAbilities")}
          name="problemSolvingAbilities"
          value={formState.problemSolvingAbilities}
          onChange={handleChange}
          info={t("expertForm.problemSolvingAbilitiesInfo")}
          minRows={1}
          error={!!validationErrors.problemSolvingAbilities}
          helperText={validationErrors.problemSolvingAbilities}
        />
        <FormTextField
          label={t("expertForm.knowledgeDepth")}
          name="knowledgeDepth"
          value={formState.knowledgeDepth}
          onChange={handleChange}
          info={t("expertForm.knowledgeDepthInfo")}
          minRows={1}
          error={!!validationErrors.knowledgeDepth}
          helperText={validationErrors.knowledgeDepth}
        />
      </Paper>
    </Grid>
  );
};

export default RolesAndResponsibilities;
